import colors from '../../style/colors';

import { sizes as loaderSizes, variants as loaderVariants } from '../spinner/spinner';

export type Size = 'auto' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
interface SizeProps {
  loaderProps: { size?: keyof typeof loaderSizes; variant?: keyof typeof loaderVariants };
  padding: string | number;
  height: string;
  fontSize: string;
}

export const sizes: Record<Size, SizeProps> = {
  auto: {
    padding: 0,
    height: 'auto',
    fontSize: '1rem',
    loaderProps: { size: 'xxs' },
  },
  xs: {
    padding: '6px 12px',
    height: '24px',
    fontSize: '0.75rem',
    loaderProps: { size: 'xxs' },
  },
  sm: {
    padding: '6px 16px',
    height: '32px',
    fontSize: '0.875rem',
    loaderProps: { size: 'xxs' },
  },
  md: {
    padding: '8px 16px',
    height: '40px',
    fontSize: '1rem',
    loaderProps: { size: 'xs' },
  },
  lg: {
    padding: '6px 16px',
    height: '48px',
    fontSize: '1rem',
    loaderProps: { size: 'sm' },
  },
  xl: {
    padding: '0',
    height: '130px',
    fontSize: '1rem',
    loaderProps: { size: 'md' },
  },
};

type Variant =
  | 'action'
  | 'secondary'
  | 'secondary-clean'
  | 'secondary-opacity'
  | 'secondary-action'
  | 'action-ghost'
  | 'action-yellow-gray'
  | 'linkedin'
  | 'clean'
  | 'cherry-clean'
  | 'danger';

interface VariantProps {
  loaderProps?: { size?: keyof typeof loaderSizes; variant?: keyof typeof loaderVariants };
  bgColor?: string;
  activeBgColor?: string;
  activeColor?: string;
  borderColor?: string;
  hoverBorderColor?: string;
  activeBorderColor?: string;
  hoverBgColor?: string;
  color?: string;
  hoverColor?: string;
  disabledBackground?: string;
  disabledColor?: string;
  disabledBorder?: string;
  loadingBorderColor?: string;
}

export const variants: Record<Variant, VariantProps> = {
  action: {
    bgColor: 'action',
    color: colors.white,
    loaderProps: { variant: 'gray' },
    disabledColor: colors.gray600,
  },
  danger: {
    bgColor: colors.negative,
    color: colors.white,
    hoverBgColor: colors.negativeDark,
    activeBgColor: '#9a2f38',
    disabledBackground: colors.gray300,
    disabledColor: colors.gray600,
    loaderProps: { variant: 'gray' },
  },
  secondary: {
    bgColor: colors.gray100,
    activeBgColor: 'actionLight',
    activeColor: 'action',
    activeBorderColor: 'actionLight',
    borderColor: colors.gray100,
    hoverBorderColor: colors.gray300,
    hoverBgColor: colors.gray300,
    color: colors.gray900,
    loaderProps: { variant: 'gray' },
  },
  'secondary-clean': {
    bgColor: colors.transparent,
    activeBgColor: 'actionLight',
    activeColor: 'action',
    activeBorderColor: 'actionLight',
    borderColor: colors.transparent,
    hoverBgColor: colors.gray100,
    color: colors.gray900,
    disabledColor: colors.gray600,
    loaderProps: { variant: 'gray' },
  },
  'secondary-opacity': {
    bgColor: colors.transparent,
    activeBgColor: 'rgba(255, 255, 255, 0.45)',
    activeColor: 'action',
    activeBorderColor: colors.transparent,
    borderColor: colors.transparent,
    hoverBgColor: 'rgba(255, 255, 255, 0.35)',
    color: colors.gray900,
    disabledColor: colors.gray600,
    loaderProps: { variant: 'gray' },
  },
  'secondary-action': {
    bgColor: colors.transparent,
    activeBgColor: colors.gray100,
    activeColor: 'action',
    activeBorderColor: colors.gray100,
    borderColor: colors.transparent,
    hoverBgColor: colors.gray100,
    color: 'action',
    disabledColor: colors.gray600,
    loaderProps: { variant: 'gray' },
  },
  'action-ghost': {
    color: 'action',
    bgColor: colors.white,
    borderColor: 'action',
    hoverColor: colors.white,
    hoverBgColor: 'action',
    disabledColor: colors.gray600,
    disabledBackground: colors.white,
    disabledBorder: colors.gray600,
    loadingBorderColor: 'action',
    loaderProps: { variant: 'action' },
    activeColor: colors.white,
    activeBgColor: 'actionColorDark',
    activeBorderColor: 'actionColorDark',
  },
  'action-yellow-gray': {
    bgColor: colors.transparent,
    color: colors.gray600,
    hoverBgColor: colors.gray100,
    hoverBorderColor: colors.transparent,
    activeBorderColor: colors.transparent,
    disabledBorder: colors.transparent,
    activeBgColor: colors.lightSun,
    activeColor: colors.darkSun,
    disabledBackground: colors.gray100,
    loaderProps: {},
  },
  linkedin: {
    bgColor: colors.linkedin,
    color: colors.white,
    hoverBgColor: '#042b52',
    activeBgColor: '#032648',
    loaderProps: {},
  },
  clean: {
    bgColor: colors.transparent,
    color: 'inherit',
    loaderProps: {},
  },
  'cherry-clean': {
    color: colors.gray900,
    bgColor: colors.transparent,
    hoverColor: colors.coral,
    disabledColor: colors.gray600,
    loadingBorderColor: colors.transparent,
    activeColor: colors.coral,
    activeBgColor: colors.gray100,
    borderColor: colors.transparent,
    hoverBgColor: colors.gray300,
    loaderProps: { variant: 'gray' },
  },
};
